import { SVGProps } from '@components/Icon/types';

export const Underline = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(6, 5)">
      <path d="M12 14H0V13.567H12V14Z" fill={fill} />
      <path
        d="M10.813 7.93245C10.813 8.89748 10.6071 9.74137 10.1947 10.4637C9.78791 11.186 9.2224 11.746 8.49931 12.1448C7.77623 12.5435 6.94336 12.7434 6 12.7434C5.05651 12.7434 4.22266 12.5436 3.49951 12.1448C2.77668 11.7461 2.20936 11.1885 1.79704 10.4722C1.39031 9.74983 1.18703 8.90326 1.187 7.93245V0.00846579L2.71212 0V7.80183C2.71212 8.39116 2.80743 8.90588 2.99941 9.34502C3.19714 9.77846 3.45769 10.1397 3.7797 10.4286C4.10173 10.7176 4.45484 10.9348 4.83901 11.0793C5.22878 11.218 5.61588 11.2873 6 11.2873C6.38971 11.2873 6.77955 11.2152 7.16926 11.0708C7.55909 10.9264 7.91219 10.7118 8.22857 10.4286C8.55055 10.1397 8.80733 9.77569 8.99941 9.33656C9.1915 8.89733 9.28788 8.38554 9.28788 7.80183V0H10.813V7.93245Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'underline';
